import axios from "axios";
import { notConnectedMessage } from "../../components/constants";
import { BASE_API } from "../../utils/constants";

export class ArchiveService {
    static url = `${BASE_API}/user`;

    static async getUsers(
        { page = 1, limit = 10000, filter = {} },
        org: any,
        api_key: string
    ) {
        try {
            console.log("org");
            const response = await axios.get(ArchiveService.url + "/archive", {
                withCredentials: true,
                headers: {
                    "x-org": org,
                    authorization: `Bearer ${api_key}`,
                },
                params: {
                    page,
                    limit,
                    filter,
                },
            });
            return [response.data, null];
        } catch (err: any) {
            return [null, err?.response?.data?.message || notConnectedMessage];
        }
    }

    static async restoreUser(item: any, org: string) {
        console.log(item, org);
        try {
            const response = await axios.patch(
                ArchiveService.url + "/restore/archive",
                {},
                {
                    withCredentials: true,
                    headers: {
                        "x-org": org,
                    },
                    params: { pin: item?.savedPin, branchId: item?.branch?.id },
                }
            );
            return [response.data, null];
        } catch (err: any) {
            return [null, err.response?.data?.message || notConnectedMessage];
        }
    }

    static async deleteUser(item: any, org: any) {
        try {
            console.log(item, org, "org and item");

            const response = await axios.delete(
                ArchiveService.url + "/delete/archive",
                {
                    withCredentials: true,
                    headers: {
                        "x-org": org,
                    },
                    params: {
                        pin: item?.savedPin,
                        branchId: item?.branch?.id,
                    },
                }
            );

            return [response.data, null];
        } catch (err: any) {
            console.log(err);
            return [null, err.response?.data?.message || notConnectedMessage];
        }
    }
}
